// src/stone/icons/DollarShield.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarShield = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12.968 4.712v14.576h-2V4.712z" }),
      /* @__PURE__ */ jsx("path", { d: "M11.361 6.053c1.492-.107 3.2.27 4.12.776l.877.482-.963 1.752-.877-.481c-.535-.295-1.848-.617-3.014-.534-.575.041-.988.174-1.231.346-.19.134-.316.31-.316.67 0 .458.17.723.502.965.398.293.973.505 1.727.756l.162.054c.65.215 1.441.477 2.065.88.748.481 1.369 1.236 1.369 2.393 0 .965-.324 1.774-.946 2.361-.595.563-1.37.835-2.126.948-1.5.225-3.278-.117-4.674-.621l-.941-.34.679-1.88.94.338c1.225.443 2.65.683 3.699.525.517-.077.853-.237 1.05-.423.17-.16.319-.417.319-.908 0-.3-.108-.49-.452-.713-.402-.259-.961-.445-1.704-.692l-.073-.025c-.702-.234-1.584-.531-2.277-1.04-.761-.558-1.319-1.385-1.319-2.578 0-1.018.448-1.8 1.163-2.305.662-.467 1.487-.652 2.241-.706" }),
      /* @__PURE__ */ jsx("path", { d: "m12-.022 11 2.305v11.288c0 2.786-1.174 5.444-3.243 7.395C17.69 22.915 14.9 24 12 24s-5.69-1.085-7.757-3.034C2.174 19.016 1 16.356 1 13.571V2.283zm-9 3.93v9.663c0 2.216.933 4.354 2.615 5.94C7.299 21.099 9.595 22 12 22s4.701-.901 6.385-2.49C20.067 17.926 21 15.788 21 13.572V3.907l-9-1.885z" })
    ]
  }
);
var DollarShield_default = DollarShield;

export {
  DollarShield_default
};
